var cache = {};
const setCache = async (key, data, expri = 1000) => {
    var ex = (new Date()).getTime();
    ex = ex + expri;
    cache[key] = { data, expri: ex }


}
const getCache = async (key) => {
    if (cache[key]) {

        return cache[key].data;
    }
    return null;
}
const removeCache = async (key) => {
    if (cache[key]) {
        delete cache[key];
    }

}

export { setCache, getCache, removeCache }